import type { Language } from '@ps/poker-games-tile-mappers';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { mapTableType, mapTournType, useGetCurrentDate, useHomeGamesWidget } from '@swf/poker';

import type { GamesByClubs } from '../types/common';

const useMapGameData = ({ shouldMapTables = false, shouldMapTournaments = false }) => {
  const { widgetSelect } = useHomeGamesWidget();
  const scheduledTables = useSelector(widgetSelect.scheduledTables);
  const tourns = useSelector(widgetSelect.tournaments);
  const recentTourns = useSelector(widgetSelect.recentTourns);
  const { timeZoneName } = useGetCurrentDate(new Date());
  const language = useSelector(select.locale.get);

  const mappedTables = useMemo(
    () =>
      shouldMapTables
        ? mapTableType(scheduledTables ?? [], language as Language, timeZoneName)
        : {},
    [scheduledTables, shouldMapTables, timeZoneName, language]
  ) as GamesByClubs;

  const mappedTournaments = useMemo(
    () =>
      shouldMapTournaments ? mapTournType(tourns ?? [], language as Language, timeZoneName) : {},
    [tourns, shouldMapTournaments, timeZoneName, language]
  ) as GamesByClubs;

  const mappedRecentTournaments = useMemo(
    () =>
      shouldMapTournaments
        ? mapTournType(recentTourns ?? [], language as Language, timeZoneName)
        : {},
    [recentTourns, shouldMapTournaments, timeZoneName, language]
  ) as GamesByClubs;

  return { mappedTables, mappedTournaments, mappedRecentTournaments };
};

export default useMapGameData;
